module.exports = __webpack_public_path__ + "static/media/ReturnReason1.4a1d47a4.png";